export default "__VITE_ASSET__68f4822f__"